export default __webpack_public_path__ + "static/media/image 9.8dd069ea.png";